import { IconStorefront, Text } from '@vtex/admin-ui'
import { RuleContent, RuleDescription, RuleIcon } from '../../RuleStack'
import { FormattedMessage } from 'react-intl'
import { messages } from '../messages'
import { Tag } from '../../../Tag'

export function MaxUsageView(props: { restriction: number }) {
  const { restriction } = props

  return (
    <>
      <RuleIcon>
        <IconStorefront />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.maxUsage}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>
          <FormattedMessage
            {...messages.view.quantity}
            values={{ value: restriction }}
          />
        </Tag>
      </RuleContent>
    </>
  )
}
